import { render, staticRenderFns } from "./DescriptionsEditor.vue?vue&type=template&id=7dc1b6aa&scoped=true"
import script from "./DescriptionsEditor.vue?vue&type=script&lang=js"
export * from "./DescriptionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1b6aa",
  null
  
)

export default component.exports